import './tabs.scss';
import { initVisibleFields } from '../form/form';

const tabs = document.querySelectorAll('[data-init="tabs"]');

function getPanelFromTab(tab) {
	const button = tab.root_;
	const panelId = button.dataset.tabsPanelId;
	const panel = document.querySelector(`#${panelId}`);

	return panel;
}

tabs.forEach(element => {
	const tabBar = new window.MDCTabBar(element);
	const panels = tabBar.tabList_.map(getPanelFromTab);

	element.addEventListener('MDCTabBar:activated', event => {
		const tab = tabBar.tabList_[event.detail.index];
		const targetPanel = getPanelFromTab(tab);

		panels.forEach(panel => {
			const isTarget = panel == targetPanel;

			panel.classList.toggle('is-active', isTarget);

			// Fix floating label size
			if (isTarget) {
				initVisibleFields(panel);
			}
		});
	});
});
